import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

const Tooltip = defineSlotRecipe({
  slots: ['content', 'arrow'],
  base: {
    content: {
      '--tooltip-bg': colors.podcastShade500,
      color: 'podcastShade100',
      fontSize: '14px',
    },
  },
  variants: {
    visual: {
      alituWaves: {
        content: {
          '--tooltip-bg': colors.podcastShade600,
          borderRadius: '8px',
          textAlign: 'center',
          py: '5px',
        },
      },
      destructive: {
        content: {
          '--tooltip-bg': colors.podcastRed600,
        },
      },
    },
  },
});

export default Tooltip;
